import { call, put, takeEvery } from 'redux-saga/effects';
import { safe } from './util';
import {
  CHANGE_USER_PASSWORD_SAGA, deleteUserInfo, LOGOUT_USER_SAGA,
  REFRESH_USER_INFO_SAGA,
  RESET_USER_PASSWORD_SAGA,
  SEND_VERIFICATION_CODE_SAGA,
  setRegisterSuccessModal, SYNC_AVATAR_SAGA,
  UPDATE_USER_INFO_SAGA,
  updateNextVerifyCountdown,
  updateUserInfo,
  USER_LOGIN_SAGA,
  USER_REGISTER_SAGA,
} from '../actions/user';
import {
  changePassword as sendChangePassword,
  getCode,
  login as sendLogin,
  resetPassword,
  sendRegister,
  update as sendUpdate,
  syncAvatar as sendSyncAvatar,
  refreshUserInfo as sendRefreshUserInfo,
  logout as sendLogout
} from '../api/user';
import { delay } from 'redux-saga';
import { redirectAction } from '../actions/redirect';
import { queryObject } from '../util';
import { toast } from 'react-toastify';

const changeImageSize = imgUrl => imgUrl && imgUrl.replace(/\/\d+$/, '/0');

function* register(action) {
  if (!action || !action.payload) return;
  const { payload } = action;
  const { agencyKey } = queryObject();
  if (agencyKey) {
    payload.agency_key = agencyKey;
  }
  try {
    const response = yield call(sendRegister, payload);
    yield put(updateUserInfo(response));
    yield put(setRegisterSuccessModal(true));
  } catch (ex) {
    toast.dismiss();
    if (ex.status === 400 && ex.json && ex.json.error && ex.json.error.indexOf('verification code') > -1) {
      toast.error(
        '验证码错误，请重新获取验证码',
        {
          position: toast.POSITION.TOP_CENTER,
        }
      );
    } else {
      toast.error(
        '提交失败，请检查网络后重试',
        {
          position: toast.POSITION.TOP_CENTER,
        }
      );
    }
  }
}

function* sendCode({ cellphone, scope }) {
  try {
    let { nextVerify } = yield call(getCode, { cellphone, scope });
    while (nextVerify) {
      yield put(updateNextVerifyCountdown(nextVerify));
      nextVerify--;
      yield call(delay, 1000);
    }
    yield put(updateNextVerifyCountdown(0));
  } catch (e) {
    // alert('手机号已注册');
  }
}

function* login({ cellphone, password }) {
  try {
    const payload = yield call(sendLogin, { cellphone, password });
    payload.avatar = changeImageSize(payload.avatar);
    yield put(updateUserInfo(payload));
    yield put(redirectAction('/me'));
  } catch (e) {
    alert('手机号或密码错误');
  }
}

function* reset({ cellphone, code, new_password }) {
  try {
    const payload = yield call(resetPassword, { cellphone, code, new_password });
    payload.avatar = changeImageSize(payload.avatar);
    yield put(updateUserInfo(payload));
    yield put(redirectAction('/me'));
  } catch (e) {
    alert('手机号或验证码错误');
  }
}

function* loginIfNecessary(e, alerttext) {
  alerttext = alerttext || '原密码错误';
  if (e.message.startsWith('400')) {
    alert(alerttext);
  } else {
    alert('会话超时，请重新登陆');
    yield put(redirectAction('/login'));
  }
}

function* update(action) {
  try {
    if (!action || !action.payload) return;
    const { payload } = action;
    const response = yield call(sendUpdate, payload);
    yield put(updateUserInfo(response));
    yield put(redirectAction('/me'));
  } catch (e) {
    yield call(loginIfNecessary, e);
  }
}

function* syncAvatar() {
  try {
    yield call(sendSyncAvatar);
  } catch (e) {
    yield call(loginIfNecessary, e, '请通过微信公众号进行同步操作');
  } finally {
    yield call(refreshUserInfo);
  }
}
export function* changePassword({ old_password, new_password }) {
  try {
    const payload = yield call(sendChangePassword, { old_password, new_password });
    payload.avatar = changeImageSize(payload.avatar);
    yield put(updateUserInfo(payload));
    yield put(redirectAction('/me'));
  } catch (e) {
    yield call(loginIfNecessary, e);
  }
}

export function* refreshUserInfo() {
  try {
    const payload = yield call(sendRefreshUserInfo);
    payload.avatar = changeImageSize(payload.avatar);
    yield put(updateUserInfo(payload));
  } catch (e) {
    yield call(loginIfNecessary, e);
  }
}

export function* logout() {
  try {
    yield call(sendLogout);
  } catch (e) {
    // no need to alert, just redirect
  } finally {
    yield put(deleteUserInfo());
    yield put(redirectAction('/login'));
  }
}

export function* watchRegistration() {
  yield takeEvery(USER_REGISTER_SAGA, safe(register));
}

export function* watchVerificationCode() {
  yield takeEvery(SEND_VERIFICATION_CODE_SAGA, safe(sendCode));
}

export function* watchUserLogin() {
  yield takeEvery(USER_LOGIN_SAGA, safe(login));
}

export function* watchUpdateUserInfo() {
  yield takeEvery(UPDATE_USER_INFO_SAGA, safe(update));
}

export function* watchSyncAvatar() {
  yield takeEvery(SYNC_AVATAR_SAGA, safe(syncAvatar));
}

export function* watchResetPassword() {
  yield takeEvery(RESET_USER_PASSWORD_SAGA, safe(reset));
}

export function* watchChangePassword() {
  yield takeEvery(CHANGE_USER_PASSWORD_SAGA, safe(changePassword));
}

export function* watchRefreshUserInfo() {
  yield takeEvery(REFRESH_USER_INFO_SAGA, safe(refreshUserInfo));
}

export function* watchLogout() {
  yield takeEvery(LOGOUT_USER_SAGA, safe(logout));
}



// WEBPACK FOOTER //
// ./src/sagas/user.js